import { render, staticRenderFns } from "./AdsPixelFacebookConfiguration.vue?vue&type=template&id=58e051f2"
import script from "./AdsPixelFacebookConfiguration.vue?vue&type=script&lang=js"
export * from "./AdsPixelFacebookConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports